<template>
  <div class="detail-content">
    <el-form :model="form" label-width="auto" :rules="rules" ref="formRef">
      <section class="detail-warp-scroll">
        <div class="title">
          <span>产品线基本信息</span>
        </div>
        <el-form-item label="产品线名称" class="width-500" prop="name">
          <el-input v-model="form.name" placeholder="" disabled />
        </el-form-item>
        <el-form-item
          label="产品线负责人"
          class="width-500"
          prop="principalName"
        >
          <el-input v-model="form.principalName" placeholder="" disabled />
          <div>产品线负责人可以设定价格、选择合作团队</div>
        </el-form-item>
        <el-form-item label="产品线类型" class="width-500" prop="bagType">
          <el-select v-model="form.bagType" placeholder="" disabled>
            <el-option label="商控" :value="1" />
            <el-option label="绝对控制" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="产品线说明" class="width-500" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            placeholder=""
            disabled
            :autosize="{ minRows: 2, maxRows: 5 }"
          />
        </el-form-item>

        <div class="title">
          <span>产品信息</span>
        </div>
        <el-form-item label="销售商品" class="width-500 display-flex-b">
          <div class="goods-left">
            <CbProductDom
              ref="RefCbProductDom"
              :proudctItem="form.proudctItem"
            />
          </div>
        </el-form-item>

        <el-form-item label="销售分类" class="width-500">
          <el-select v-model="form.saleCategoryId" placeholder="" disabled>
            <el-option
              v-for="item in salesControlType"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
              v-if="salesControlType.length > 0"
            >
            </el-option>
          </el-select>
          <div class="tips-desc">
            客户能够在合作销售专区中，对应的销售分类下看到商品
          </div>
        </el-form-item>

        <div>
          <!-- <div class="detail-title">授权地域</div>
        <el-divider> </el-divider> -->

          <div class="team-tree width-500">
            <CbTeamTree
              :labelText="'授权地域'"
              ref="RefCbTeamTree"
              :data="form.teamData"
              :isShowCheckBox="true"
              @handleCheckChange="handleCheckChange"
            />
          </div>
        </div>
      </section>

      <div class="detail-footer-warp">
        <div class="left-warp">
          <el-button
            type="primary"
            @click="onSubmit('pass')"
            v-if="pageType == 'audit' && form.applyStatus == 1"
            size="small"
            >审核通过</el-button
          >
          <el-button
            type="primary"
            @click="onSubmit('eject')"
            v-if="pageType == 'audit' && form.applyStatus == 1"
            size="small"
            >驳回</el-button
          >
          <el-button
            type="primary"
            @click="onSubmit('save')"
            v-if="pageType == 'edit' && form.applyStatus == 2"
            size="small"
            >保存</el-button
          >
          <el-button @click="backPage" size="small">返回</el-button>
        </div>
        <div class="right-warp"></div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import CbTeamTree from "@/components/CbTeamTree";
import CbProductDom from "@/components/CbProductDom";
import {
  dfcTree,
  regionTree,
} from "@/api/businessPlatform/relationshipMaintenance";
import {
  plProductBagsIdGet,
  plSaleCategorys,
  plProductBagsAuditReject,
  plProductBagsAuditPass,
  plProductBagsIdPut,
} from "@/api/saleRule/agent";
export default {
  name: "productLineAuditDetail",
  components: { CbTeamTree, CbProductDom },
  data() {
    return {
      pageType: "",
      salesControlType: [],
      form: {
        name: "",
        teamData: [],
        proudctItem: {},
        allCheckAreaIds: [],
      },
      rules: {
        // allCheckAreaIds: [
        //   { required: true, message: "请选择授权地域", trigger: "change" },
        // ],
      },
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    ...mapState("App", {
      selectList: "selectList",
    }),
    getStatus() {},
  },
  methods: {
    // 获取销售分类
    getPlSaleCategorys(val) {
      plSaleCategorys({
        size: 50,
        current: 1,
      }).then((res) => {
        this.salesControlType = res;
      });
    },

    // 获取地域树
    async getTeamTree() {
      return new Promise((resolve, reject) => {
        regionTree()
          .then((res) => {
            if (res && res.data.length > 0) {
              resolve(res.data);
            } else {
              reject([]);
            }
          })
          .catch((err) => {
            reject([]);
          });
      });
    },

    onSubmit(type) {
      if (type == "eject") {
        //驳回状态不保存授权区域
        this.auditReject();
      } else {
        this.$refs.RefCbTeamTree.formCheck()
          .then((res) => {
            if (type == "pass") {
              this.auditPass();
            }
            if (type == "save") {
              this.save();
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    },

    auditReject() {
      this.$prompt("请输入驳回原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "请输入20字以内驳回原因",
      })
        .then(({ value }) => {
          let params = {
            ...this.form,
            id: this.$route.query.id,
            applyStatus: 3,
            remark: value,
          };
          params.areaCodes = []; //驳回状态不保存授权区域
          delete params.teamData;
          delete params.allCheckAreaIds;
          plProductBagsAuditReject(params).then((res) => {
            this.$message.success("驳回成功");
            // this.$router.go(-1);
            this.$router.push({
              path: "/agentSalesControl/agentSalesControl-productLineAudit",
            });
          });
        })
        .catch(() => {});
    },

    // 保存
    save() {
      // plProductBagsIdPut
      let params = {
        ...this.form,
        id: this.$route.query.id,
        applyStatus: 2,
      };

      console.log(this.form.allCheckAreaIds, "---this.form.allCheckAreaIds");
      params.areaCodes = this.form.allCheckAreaIds;
      params.type = 1; // type  1 平台 2商户
      console.log("params", params);
      plProductBagsIdPut(params).then((res) => {
        this.$message.success("保存成功");
        // this.$router.go(-1);
        this.$router.push({
          path: "/agentSalesControl/agentSalesControl-productLineAudit",
        });
      });
    },

    backPage() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/agentSalesControl/agentSalesControl-productLineAudit",
      });
    },

    async query() {
      let teamData = await this.getTeamTree();
      let parmas = {
        id: this.$route.query.id,
        type: 1, // type  1 平台 2商户
      };
      plProductBagsIdGet(parmas).then((res) => {
        if (res && res.data) {
          let newData = { ...res.data };
          newData.proudctItem = res.data.plProductGoodsBaseDTO;
          newData.teamData = teamData;
          this.form = newData;
          this.form.allCheckAreaIds = res.data.platformAreaCodes || [];
          let checkAreaIds = res.data.platformAreaCodes || [];
          this.$refs.RefCbTeamTree.publicSetCheckNodes(checkAreaIds);
          this.$refs.RefCbTeamTree.formTree.allCheckKeys = checkAreaIds;
        }
      });
    },

    // 选中区域的Id
    handleCheckChange(Ids, nodes) {
      // console.log("nodes", nodes);
      const areaIds = nodes
        .filter((item) => {
          return !item.children;
        })
        .map((item) => {
          return item.id;
        });
      this.form.allCheckAreaIds = areaIds;
      console.log("this.form.allCheckAreaIds", this.form.allCheckAreaIds);
    },

    //审核通过
    auditPass() {
      this.$confirm("确认审核通过？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let params = {
            ...this.form,
            id: this.$route.query.id,
            applyStatus: 2,
            remark: "", //审核通过不输入驳回原因
          };
          params.areaCodes = this.form.allCheckAreaIds;
          delete params.teamData;
          delete params.allCheckAreaIds;
          console.log("params", params);
          plProductBagsAuditPass(params).then((res) => {
            this.$message.success("审核通过");
            // this.$router.go(-1);
            this.$router.push({
              path: "/agentSalesControl/agentSalesControl-productLineAudit",
            });
          });
        })
        .catch(() => {});
    },
  },
  created() {},
  mounted() {
    this.query();
    this.pageType = this.$route.query.type;
    this.getPlSaleCategorys();
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 16px;
  margin-bottom: 10px;
  position: relative;
  padding-left: 10px;
  color: #000000;
  font-weight: bold;
  :before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 18px;
    background-color: #f5222d;
    margin-right: 10px;
    position: absolute;
    top: 3px;
    left: 0;
  }
  .desc {
    color: #595959;
    font-size: 14px;
    margin-left: 10px;
  }
}
.detail-content {
  background: #fff;
  padding: 20px;
  height: calc(100% - 10px);
  overflow: auto;
}

.detail-warp-scroll {
  height: calc(100% - 50px);
  overflow: auto;
}

.team-tree {
  // overflow: auto;
  // margin-bottom: 20px;
}
.width-500 {
  width: 500px;
}
.detail-footer-warp {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .left-warp {
    width: 80%;
  }
  .right-warp {
    width: 20%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
